// src/hooks/useSidebarCounts.js
import { useState, useEffect } from 'react';
import { fetchApi } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export const useSidebarCounts = () => {
  const [counts, setCounts] = useState({
    userManagement: 0,
    campaignManagement: 0,
    depositManagement: 0,
    ticketSupport: 0,
    notificationManagement: 0,
    referralSettings: 0
  });
  
  const { currentUser, isLoading } = useAuth();

  useEffect(() => {
    const fetchCounts = async () => {
      // ⚠️ PERBAIKAN: Jangan fetch jika bukan admin
      if (!currentUser || isLoading || currentUser.role !== 'admin') {
        console.log('⏸️ Skipping sidebar fetch - not admin or no user');
        return;
      }

      try {
        console.log('📊 Fetching sidebar counts for admin:', currentUser.email);
        const res = await fetchApi('/sidebar/sidebar-counts');
        
        if (res.success) {
          setCounts(res.data);
        }
      } catch (error) {
        console.error('Error fetching sidebar counts:', error);
        // Jangan handle error - biarkan silent
      }
    };

    // Fetch only when user is admin
    if (currentUser && !isLoading && currentUser.role === 'admin') {
      fetchCounts();
    }

    // Set up polling only for admin users
    let interval;
    if (currentUser && !isLoading && currentUser.role === 'admin') {
      interval = setInterval(fetchCounts, 30000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [currentUser, isLoading]); // ← TAMBAHKAN DEPENDENCIES

  return counts;
};